module.exports = __webpack_public_path__ + "media/img/pole_e@3x-4d476a3b.svg";